import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { startErrorReporting } from "./monitoring/startErrorReporting";

startErrorReporting();

const bootMonitoring = () => {
  import("./monitoring/firebase").then(({ initMonitoring }) => {
    initMonitoring();
  });
};

if (typeof window !== "undefined") {
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(bootMonitoring, { timeout: 3000 });
  } else {
    window.setTimeout(bootMonitoring, 1500);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
